import classNames from 'classnames';
import { ReactNode, useState } from 'react';
import ChevronSm from '@alltrails/denali/icons/ChevronSm';
import Edit from '@alltrails/denali/icons/Edit';
import useTrailEditToolbar from '@/hooks/useTrailEditToolbar';
import { HelpfulLinkAdminPanelSectionName } from '../Overview/HelpfulLink';
import styles from './PlanYourVisit.module.scss';

type HelpfulLinkTagProps = {
  className?: string;
  icon: ReactNode;
  iconBackground?: 'light' | 'dark';
  id: string;
  label: string;
  adminPanelSectionName?: HelpfulLinkAdminPanelSectionName;
  onClick: (id: string) => void;
  isAdminOrPLPUser?: boolean;
  closeModal?: () => void;
};

const HelpfulLinkTag = ({
  className,
  icon,
  iconBackground = 'dark',
  id,
  label,
  onClick,
  isAdminOrPLPUser,
  adminPanelSectionName,
  closeModal
}: HelpfulLinkTagProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const { openTrailEditToolbar } = useTrailEditToolbar();
  const isEditable = !!adminPanelSectionName && isAdminOrPLPUser;

  const onEditIconClick = e => {
    e.stopPropagation();
    closeModal?.();
    openTrailEditToolbar(adminPanelSectionName);
  };
  return (
    <button
      className={classNames(styles.helpfulLinkTag, className, { [styles.adminButton]: isEditable })}
      onClick={() => onClick(id)}
      title={label}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isEditable && isHovered && (
        // avoid nested buttons
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div className={styles.iconDiv} onClick={onEditIconClick}>
          <div className={styles.editIcon} data-testid="edit-icon">
            <Edit color="--color-text-light" size="sm" />
          </div>
        </div>
      )}
      <div className={classNames(styles.iconBackground, { [styles.light]: iconBackground === 'light' })}>{icon}</div>
      <div className={styles.helpfulLinkTagLabel}>
        <div className={styles.tagName}>{label}</div>
        <ChevronSm orientation="right" />
      </div>
    </button>
  );
};

export default HelpfulLinkTag;
